import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';

import { map } from 'rxjs/operators';
import { Environment } from 'src/environments/environment';

import { CropData } from '../models';

@Injectable({
  providedIn: 'root',
})
export class CropApiService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  // change the base url to point to the according service name
  protected baseUrl = this.env.APIM_BASE_URL + '/arable-service/';

  getCrops(): Observable<CropData[]> {
    return this.http
      .get<{ crops: CropData[] }>(`${this.baseUrl}crop`)
      .pipe(map(({ crops }) => crops));
  }
}
